<template>
  <header class="page-header">
    <div class="page-header__main">
      <nav v-if="breadcrumb && breadcrumb.length" class="page-header__breadcrumb" aria-label="breadcrumb">
        <template v-for="(item, idx) in breadcrumb" :key="idx">
          <router-link
            v-if="item.to && idx < breadcrumb.length - 1"
            :to="item.to"
            class="page-header__crumb page-header__crumb--link"
          >
            {{ item.label }}
          </router-link>
          <span v-else class="page-header__crumb">{{ item.label }}</span>
          <span
            v-if="idx < breadcrumb.length - 1"
            class="page-header__crumb-sep"
            aria-hidden="true"
          >/</span>
        </template>
      </nav>

      <h1 class="page-header__title">{{ title }}</h1>
      <p v-if="subtitle" class="page-header__subtitle">{{ subtitle }}</p>
    </div>

    <div v-if="$slots.actions" class="page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    breadcrumb: {
      type: Array,
      default: () => [],
      validator: (arr) => arr.every((i) => typeof i?.label === "string"),
    },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}

.page-header__main {
  min-width: 0;
  flex: 1;
}

.page-header__breadcrumb {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  margin-bottom: var(--space-2);
  font-size: var(--font-caption-size);
  line-height: var(--font-caption-line);
  color: var(--text-tertiary);
}

.page-header__crumb {
  color: var(--text-tertiary);
  text-decoration: none;
}

.page-header__crumb--link:hover {
  color: var(--color-primary-600);
}

.page-header__crumb-sep {
  color: var(--text-disabled);
}

.page-header__title {
  margin: 0;
  font-size: var(--font-h1-size);
  line-height: var(--font-h1-line);
  font-weight: var(--font-h1-weight);
  color: var(--text-primary);
}

.page-header__subtitle {
  margin: var(--space-1) 0 0;
  font-size: var(--font-small-size);
  line-height: var(--font-small-line);
  color: var(--text-tertiary);
}

.page-header__actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
}
</style>
